import React, { useState } from 'react';
import 'twin.macro';
import { DateRange, IDateRange } from 'components/Form/DateRange';
import startOfMonth from 'utils/time/startOfMonth';
import endOfMonth from 'utils/time/endOfMonth';
import { useTranslation } from 'react-i18next';
import isValid from 'utils/time/isValid';
import { PrinterIcon } from '@heroicons/react/24/outline';
import { Main } from './Main';
import { useOutletContext } from 'react-router-dom';
import { Eleve } from 'types/eleves';
import SchoolyearButtonLink from '@teetsh/app/src/components/Buttons/SchoolyearButtonLink';
import { format } from '@teetsh/app/src/utils/time/format';

export function Presences() {
  const { eleve } = useOutletContext<{
    eleve: Eleve;
  }>();
  const [dateRange, setDateRange] = useState<IDateRange>({
    from: startOfMonth(new Date()),
    to: endOfMonth(new Date()),
  });
  const { t } = useTranslation(['common']);
  return (
    <div tw="max-w-4xl px-3 md:px-0">
      <div tw="mb-6 flex justify-end">
        <DateRange value={dateRange} onChange={setDateRange} id="date" />
        <div tw="ml-4">
          <SchoolyearButtonLink
            large
            icon={PrinterIcon}
            to={`eleves/${eleve.id}/presences/preview?from=${format(
              dateRange.from!,
              'fr-FR',
            )}&to=${format(dateRange.to!, 'fr-FR')}`}
            disabled={
              !dateRange.from ||
              !dateRange.to ||
              !isValid(dateRange.from) ||
              !isValid(dateRange.to)
            }
          >
            {t('common:buttons.pdfPreview')}
          </SchoolyearButtonLink>
        </div>
      </div>
      <Main
        eleveId={eleve.id}
        from={dateRange.from || startOfMonth(new Date())}
        to={dateRange.to || endOfMonth(new Date())}
      />
    </div>
  );
}
